import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {filter, first} from "rxjs/operators";
import {ProductService} from "../../product.service";
import {Store} from "@ngrx/store";
import {DbStoreState} from "../../../../store";
import * as fromStore from "../../../../store";
import {Product} from "../../product";
import {Config} from "../../../../config/config";
import {DbResponse} from "../../../../shared/interceptors/db-response";

@Injectable()
export class WoocommerceTaxPluginResolver implements Resolve<null> {

  constructor(
    private _productService: ProductService,
    private _store: Store<DbStoreState>
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any>|Promise<any>|any {
    return new Promise((resolve: Function, reject: Function): void => {
      const websiteId: number = route.parent.data && route.parent.data['website'] ? route.parent.data['website'].id : route.parent.parent.data['website'].id;

      this._store.select(fromStore.getWebsitePluginsAndExtensions(websiteId)).subscribe((plugins: Product[]) => {
        if (plugins) {
          let taxPlugin = plugins.find((product: Product) => product.slug === Config.woocommerceTaxPluginSlug);
          if (taxPlugin) {
            resolve(taxPlugin);
          }
          else {
            this._productService.getWordpressPlugins(websiteId, Config.woocommerceTaxPluginSlug)
              .pipe(filter((response: DbResponse): boolean => !!response),
              first())
              .subscribe((response: DbResponse): void => {
                if (response.success) {
                  resolve(response.data.find(plugin => plugin.slug === Config.woocommerceTaxPluginSlug));
                }
                else {
                  resolve(null);
                }
              });
          }
        }
        else {
          resolve(null);
        }
      });
    });
  }

}
